/*
assets from
https://pixabay.com/fi/videos/syksy-kausi-luonne-lehdet-puu-23881/
*/

import React, {useState, useEffect, Component} from 'react';
import ReactDOM from 'react-dom';

//https://github.com/FirebaseExtended/reactfire
import { 
  FirebaseAppProvider,
  useFirestore, 
  SuspenseWithPerf,
  useFirestoreCollectionData,
} from 'reactfire';


import textContent from './textContent.json';
import characters from './characters.json';
import happyMeter from './happyMeter.json';

import CharacterList from './components/characterList.js';

import './index.css';
import videoSrc from './assets/fall_looping.mp4';
import MoveableButton from './components/moveableButton.js';

import data from './firebaseConfig.json';
const firebaseConfig = data[0];

const appsUrl = "https://somebodyapp.netlify.app/";

const localStorageKeyGlobal = "user-test4567";
let lang = 0; //0 = fi, 1 = en 

//localstorage
const LS = localStorageKey => {
  const [value, setValue] = useState(
    localStorage.getItem(localStorageKey) || ''
  );
  useEffect(() => {
    localStorage.setItem(localStorageKey, value);
  }, [value, localStorageKey]);   /*  <- all dependencies must be declared to prevent errors: https://reactjs.org/docs/hooks-faq.html#is-it-safe-to-omit-functions-from-the-list-of-dependencies
                                      React Hook useEffect has a missing dependency: 'localStorageKey'. 
                                      Either include it or remove the dependency array  react-hooks/exhaustive-deps 
                                  */
  //console.log("key:",localStorageKey);
  //console.log("value:",value);
  return [value, setValue];
};

function Initials(props) {  
  return(
    <div>
      <h3>{textContent[lang].setInitialsHeader}</h3>
      <input onChange={props.onChange} maxLength="2" />
    </div>
  );
}

function Submitter(props){

  let label,label2, label3;
  if(props.labelType === "continue"){
    label = textContent[lang].labelContinue;
  }else if(props.labelType === "start"){
    label = textContent[lang].labelStart;
  }else if(props.labelType === "ready"){
    label = textContent[lang].labelReady;
  }
  else if(props.labelType === "createroom"){
    label = !props.extraConfirmNeeded ? textContent[lang].labelStart : textContent[lang].labelRoomConfirmFirstLabel;
    label2 = textContent[lang].labelRoomConfirmQuestion;
    label3 = textContent[lang].labelRoomConfirmLabel;
  }

  const [notconfirmed, setConfirmed] = useState(props.extraConfirmNeeded);

  return(
    <div>
    {
      props.extraConfirmNeeded ? 
      <div>
        { notconfirmed ? <button onClick={()=>setConfirmed(false)}>{label}</button> :   
          <div className="submitter-extra-confirmation-holder">
            <span>{label2}</span>
            <button onClick={props.onClick(true)}>{label3}</button>
          </div>
        } 
      </div>:<button onClick={props.onClick(true)}>{label}</button>
    }
    </div>
  );
}

function NewUser(props){
  const [userObject,setUserObject] = useState({cid:null,initials:null,registrationDate:null}); 
  const [user, setUser] = LS(localStorageKeyGlobal);
  console.log('user', user); 

  const ref = React.createRef();

  //get set user initials 
  const updateInitials = event => {
    let val = event.target.value;
    let timeStamp = new Date();
    if(val.length === 2){
      setUserObject(prevState => {
        return { ...prevState, initials: val, registrationDate: timeStamp }
      });
    }else{
      setUserObject(prevState => {
        return { ...prevState, initials: null }
      });      
    }
  }

  const scrollToRef = () => {
    ref.current.scrollIntoView({
      behavior: 'smooth',
      block: 'start',
    });
  }

  //get set character id
  const updateCharacter = item => {
    let val = item.id;
    setUserObject(prevState => {
      return { ...prevState, cid: val }
    });

    scrollToRef();
  }

  const submit = () => {
    setUserObject(prevState => {
      return { ...prevState, submitted: true }
    });
    console.log(userObject);
    setUser( JSON.stringify(userObject));
    //props.onUserChange(userObject);
  }

  useEffect(() => {
    if(userObject.submitted){
      props.onUserChange(userObject);
    }
  }); // if local storage object changes

  return(
    
    <div className='new-user-view'>
        <h1>{textContent[lang].splashHeader}</h1>
        <div>  
          <Initials 
            onChange={updateInitials} 
            userInitials={userObject.initials}
          />     
        </div>
        
        {
          //CIDExists ? (
          userObject.initials !== null ? (
            <div id="characterSelectHolder">
              <h3>{textContent[lang].chooseCharacterHeader}</h3>
              <CharacterList
                onClick={updateCharacter}
                activeCharacterId={userObject.cid}
              />
            </div>
          ):null
        }

        <div ref={ref} id="splashSubmitHolder">
        {
          (userObject.initials!==null && userObject.cid!==null) ? (
            <div>
              <Submitter labelType="continue" onClick={()=>submit} />
            </div>
          ):null
        } 
        </div>
    </div>
  );
  
}

function StartScreen(props){
  //console.log('props.firstLoadDone',props.firstLoadDone);
  return (
    <main>
      <div className="startscreen-header">
        <h1>{textContent[lang].splashHeader}</h1>
        <div className="start-screen-avatar">
          <div className="start-screen-avatar-icon">{characters[props.user.cid].icon}</div>
          <span className="start-screen-avatar-initials">{props.user.initials}</span>
        </div>
      </div>
      <div className="start-screen-room-select-holder">
        <label htmlFor="roomID">{textContent[lang].labelRoomID}</label>
        <div className="start-screen-room-input-section">
          <input value={props.currentRoomID} id="roomID" onChange={(e)=>props.onRoomIDChange(e.target.value)} />
          {props.givenRoomExists && props.currentRoomID ? <span className="start-screen-room-ok" role="img" aria-label="room ok">👍</span> : 
          //dont show new room message on first load
          props.firstLoadDone && props.currentRoomID ? <span className="start-screen-room-notfound">{textContent[lang].labelRoomDoesNotExist}</span>:null }
        </div>

        {
          props.currentRoomID ? (
            <Submitter 
            labelType="createroom" 
            extraConfirmNeeded={props.givenRoomExists ? false : true} 
            onClick={props.onStart} />
          ) : null
        }

        
      </div>
      {
          props.currentRoomID ? (
          <div className="shareUrl">
              <h2>Jaa huone</h2>
              <button id="copyShareUrl" onClick={ (e)=>props.copyUrl(e) }>{appsUrl}?roomid={props.currentRoomID}</button>
          </div>
        ) : null
      }
    </main>
    
  );
}

function TestSection(props){
  return(
    <div id="testSectionParent">
      <header className="header-avatar">
        <div className="avatar-icon">{characters[props.user.cid].icon}</div>
        <span className="avatar-initials">{props.user.initials}</span>
      </header>

      <main>
        <h1>{textContent[lang].testSectionHeader}</h1>
        <MoveableButton moodSelected={props.moodSelected} />
      </main>
    </div>   
  );
}

function FirebaseConnectionRead(props){
  let collection = props.collection;
  if(collection === "" || collection === null){
    collection = "test";
  }

  const ref = useFirestore().collection("production").doc("samk2020").collection(collection);
  //const fbData = useFirestoreDocData(ref);
  const fbData = useFirestoreCollectionData(ref, { idField: 'id' });
  //console.log("data",fbData);

  useEffect(() => { //need to use effect to prevent this messing up render()
    if(fbData.length!==0){
      props.checkIfRoomExists(true);
    }else{
      props.checkIfRoomExists(false);
    }
  });

  
  fbData.sort(function (a, b) {
    if (a.moodIconId > b.moodIconId) {
        return -1;
    }
    if (b.moodIconId > a.moodIconId) {
        return 1;
    }
    return 0;
  });
  
  let stackedList = [];
  for(const i in fbData){
    //console.log(fbData[i]);
    if(!stackedList[fbData[i].moodIconId]){
      stackedList[fbData[i].moodIconId] = [];
    }
    stackedList[fbData[i].moodIconId].push(fbData[i]);
    
  }

  //console.log( stackedList );
  let percentage = [];
  for(const i in stackedList){
    let total = stackedList[i].length;
    //console.log("tot " + total);
    percentage[i] = (total / fbData.length) * 100;
  }

  const moodList = stackedList.map((item,i) =>
    {
      let key = item.id+"_"+i;
      return (
        <li 
          key={key}
        >
          <ul>
            {
              item.map(itemInner =>{
                //console.log(itemInner);
                let key = itemInner.id + "_" + itemInner.moodIconId;
                //console.log(key);
                return (
                  <li key={key}>
                    {happyMeter[itemInner.moodIconId].icon}
                  </li>
                )
              })
            }
          </ul>
          <div className="mood-result-list-percentage">
            <b>{percentage[i].toFixed(2)}% </b>
          </div>
        </li>
      )
    }
  );

  const participantList = fbData.map(item =>
    {
      return (
        <li 
          key={item.id}
        >
          <div>
            <span className="paticipant-character-icon">{characters[item.cid].icon}</span>
            <span className="paticipant-character-initials">{item.initials}</span>
          </div>
        </li>
      )
    }
  );
  
  //return <p className="hideWithDelay">sad</p>;
  return (
    fbData ? <div className={props.showResults ? "mood-result-parent show" : "mood-result-parent"}>
      <h2>{textContent[lang].resultsListHeader}</h2>
      <ul className="mood-result-list-stacked">{moodList}</ul>
      
      <div className="mood-participant-list-holder">
        <div className="mood-participant-list-holder-inner">
          <h2>{textContent[lang].participantListHeader}</h2>
          <ul className="mood-participant-list">{participantList}</ul>
        </div>
      </div>
    </div> : <div className="alert">Error!</div>
    
  );
  
}

function FirebaseConnectionSet(props){
  //const ref = useFirestore().collection(props.collection)
  const ref = useFirestore().collection("production").doc("samk2020").collection(props.collection);

  ref.add(props.user).then(function() {
    console.log("Document successfully written!");
  });
  document.body.classList.add('all-done');
  return <p className="hideWithDelay"><span role="img" aria-label="done">👍</span></p>;
}

/*############################################*/
/*############################################*/
/*############################################*/
/*############################################*/
class MainView extends Component {
  constructor(props) {
      //super(props);
      super();
      
      const query = new URLSearchParams(window.location.search);
      const roomid = query.get('roomid');
      //console.log(window.location,roomid);

      this.state = {
        //firebase
        collectionToUse: roomid ? roomid : "test", //this is room number
        //docToUse:"testeriino",
        //firebase
        fullUrl:window.location,
        givenRoomExists:false,
        firstTimeUser: false,
        firstLoadDone:false,
      };
  }

  componentDidMount(){
    //only results
    const query = new URLSearchParams(window.location.search);
    let onlyResults = Boolean(query.get('onlyResults'));
    let roomid = query.get('roomid');

    //console.log("res", onlyResults);

    this.setState({
      onlyResults:onlyResults,
      collectionToUse:roomid
    });
    //only results
    
    const storedUser = localStorage.getItem(localStorageKeyGlobal);
    if(storedUser){
      let storedUserParsed = JSON.parse( storedUser );
      console.log("user exists:",storedUserParsed);
      
      this.setState({
        user:storedUserParsed,
        userDefined:true,
      });
    }else{
      console.log("create new user");
    }
  }
  
  onUserChange = (user) => {
    //console.log("user",user);
    this.setState({
      user:user,
      firstTimeUser:true,
      userDefined:true,
    });
  }
  
  onStart = () => {
    //console.log("mittariin");

    this.setState({
      openTest:true,
    });
    document.body.classList.add('prevent-scroll');
  }

  moodSelected = (moodIconId) => {
    let now = new Date();  
    if( this.state.moodIconId !== moodIconId ){
      this.setState({
        moodIconId:moodIconId,
        moodIconExists:true,
        user:{...this.state.user,moodIconId:moodIconId,moodTimestamp:now}
      });
      console.log("state updated ",moodIconId);
    }
  }

  userReady = () =>{
    //at this point results screen shows up and FirebaseConnectionSet is triggered
    console.log("siirry seuraavaan vaiheeseen");

    //merkkaa tähän localiin (ja tietty stateen), että on jo äänestänyt

    this.setState({
      showResults:true
    });

    document.body.classList.remove('prevent-scroll');
  }
  
  onRoomIDChange = (newRoomID) =>{
    if( this.state.docToUse !== newRoomID ){
      //console.log("new room id ", newRoomID);
      this.setState({
        collectionToUse:newRoomID
      });
    }
  }
 
  checkIfRoomExists = (exists) =>{
    //console.log("yes",exists);
    if( this.state.givenRoomExists !== exists ){
      //console.log("yes");
      this.setState({
        firstLoadDone:true,
        givenRoomExists:exists
      });
    }  
  }

  copyUrl = (e) => {
   
    if( !this.state.shareUrlCopied ){
      e.target.classList.add("text-copied");
      var textField = document.createElement('textarea')
      textField.innerText = e.target.innerHTML;
      document.body.appendChild(textField)
      textField.select()
      document.execCommand('copy')
      textField.remove()

      console.log(e.target.innerHTML + " copied");
      
      this.setState({
        shareUrlCopied:true
      });
    }
  }

  render() {
      return (
        <div id="the-main-view" className="main-view">
          {
          //needs to be muted to autoplay
          //näytön korkeus menee pieleen. Eli jatka nappi ei näy desktop!!!!!!!!!!!!
          //preload
          }
          <video id="videoBg" loop autoPlay muted> 
            <source src={videoSrc} type="video/mp4" />
          </video>
          <div id="theApp">
            <FirebaseAppProvider firebaseConfig={firebaseConfig}>
              {
                this.state.onlyResults ? (
                  <div>
                    <p className="only-results-room-id">Huone: {this.state.collectionToUse}</p>
                    <SuspenseWithPerf fallback={<div className="loader"></div>} traceId={'load-fb-status'}>
                      <FirebaseConnectionRead showResults={true} checkIfRoomExists={(exists)=>this.checkIfRoomExists(exists)} collection={this.state.collectionToUse} doc={this.state.docToUse} />
                    </SuspenseWithPerf>
                  </div>
                ):null
              }  
              {
              this.state.showResults ? (
                //write user data to firebase
                <>
                  <div>
                    <h1>{textContent[lang].resultHeader}</h1>
                  </div>

                  <SuspenseWithPerf fallback={<div className="loader-holder"><div className="loader"></div></div>} traceId={'load-fb-status'}>
                      <FirebaseConnectionSet user={this.state.user} collection={this.state.collectionToUse} />
                  </SuspenseWithPerf>
                </>
              ):(
                <>
                  <div id="mainSection">
                    {!this.state.openTest ? (
                      <div id="splash">
                        {!this.state.userDefined ? (
                          <NewUser onUserChange={(user)=>this.onUserChange(user)} />
                        ):<StartScreen 
                          user={this.state.user} 
                          givenRoomExists={this.state.givenRoomExists} 
                          currentRoomID={this.state.collectionToUse} 
                          onRoomIDChange={ (newRoomID) => this.onRoomIDChange(newRoomID) } 
                          onStart={()=>this.onStart}
                          firstLoadDone={this.state.firstLoadDone}
                          copyUrl={ (e) => this.copyUrl(e) } />
                        }
                      </div>
                    ):(
                      <TestSection onClick={()=>this.userReady} moodSelected={(iconId)=>this.moodSelected(iconId)} user={this.state.user} />
                    )
                    }
                    {this.state.moodIconExists ? (
                      <div className="test-section-submit-holder">
                        <Submitter labelType="ready" onClick={()=>this.userReady} />
                      </div>
                    ):null 
                    }
                  </div>
                </>
              )
              }
              <SuspenseWithPerf fallback={<div className="loader"></div>} traceId={'load-fb-status'}>
                <FirebaseConnectionRead showResults={this.state.showResults} checkIfRoomExists={(exists)=>this.checkIfRoomExists(exists)} collection={this.state.collectionToUse} doc={this.state.docToUse} />
              </SuspenseWithPerf>     
            </FirebaseAppProvider>
          </div>
        </div>
      );
  }
}

// ========================================

ReactDOM.render(
  <MainView />,
  document.getElementById('root')
);
